import * as tslib_1 from "tslib";
import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';
var DeleteDialogComponent = /** @class */ (function () {
    function DeleteDialogComponent(dialogRef) {
        this.dialogRef = dialogRef;
    }
    DeleteDialogComponent = tslib_1.__decorate([
        Component({
            selector: 'ext-delete-dialog',
            template: "<h1 mat-dialog-title class=\"mat-headline\"> Are sure you want to delete? </h1> <!-- <mat-dialog-content> <p>This will delete the record permanently !</p> </mat-dialog-content> --> <mat-dialog-actions> <button mat-button [mat-dialog-close]=\"true\"> Yes</button> <span fxFlex></span> <button mat-button [mat-dialog-close]=\"false\">No</button> </mat-dialog-actions>"
        }),
        tslib_1.__metadata("design:paramtypes", [MatDialogRef])
    ], DeleteDialogComponent);
    return DeleteDialogComponent;
}());
export { DeleteDialogComponent };
//# sourceMappingURL=delete-dialog.componet.js.map